import { Version } from '@angular/core';

/**
 * Upstream replaces 'ANGULARFIRE2_VERSION' at build time; ours names the vendored source (reported to
 * Firebase through firebase.registerVersion('angularfire', ...)).
 */
export const VERSION = new Version('19.2.0-newgenus');
